<div class="w-full flex justify-center " style="">
  <div class="flex-none xl:px-8 py-10 sm:py-0 block small-device-compact-calendar"
       style="width: 26rem;">
    <div class="flex items-center text-center text-gray-900">
      <button (click)="previousMonth()"
              class="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 cursor-pointer"
              type="button">
        <span class="sr-only">Previous month</span>
        <svg aria-hidden="true" class="h-5 w-5" viewBox="0 0 20 20">
          <path clip-rule="evenodd"
                d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                fill-rule="evenodd"/>
        </svg>
      </button>
      <div
        class="flex-auto text-sm font-semibold">{{ activeDate | date : globalDateService.getDateformat(GlobalDateFormat.MONTHNAME_YEAR) }}
      </div>
      <button (click)="nextMonth()"
              class="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 cursor-pointer"
              type="button">
        <span class="sr-only">Next month</span>
        <svg aria-hidden="true" class="h-5 w-5" viewBox="0 0 20 20">
          <path clip-rule="evenodd"
                d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                fill-rule="evenodd"/>
        </svg>
      </button>
    </div>
    <div class="mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500">
      <div>M</div>
      <div>D</div>
      <div>M</div>
      <div>D</div>
      <div>F</div>
      <div>S</div>
      <div>S</div>
    </div>
    <div class="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200">

      @for (day of dates; track day) {
        <!--
          `border-[3px]`, NOT Bootstrap's `border-3` (Bug #234). Bootstrap's `.border-3` is
          `border-width: 3px !important` from the globally loaded bootstrap.min.css; Tailwind's default scale
          only has 0/2/4/8, so the exact translation is the arbitrary value. 3px is kept deliberately: the
          marked-day ring on the `<time>` below is `border-2`, and today's ring is one step heavier so the two
          states stay distinguishable. Dropping to `border-2` would make them identical, `border-4` would
          visibly thicken the cell — either would be a redesign, not a bug fix.
        -->
        <button (click)="daySelectedEvent(day)"
                [ngClass]="{'rounded-tl-lg':$index == 0
            , 'rounded-tr-lg':$index == 6,
            'rounded-bl-lg':$index == 35,
            'rounded-br-lg':$index == 41,
            '!bg-theme-primary-700 text-white': isSelected(day) || singleDaySelected===day,
            'border-[3px] border-theme-primary-900 text-theme-primary-900': isToday(day)}
            "
                class=" bg-gray-50 py-1.5  text-gray-400  focus:z-10 cursor-none hover:!bg-theme-primary-900 hover:text-white"
                id="day-{{$index}}"


                type="button">
          <!--hover:!bg-indigo-200 hover:text-white (mouseover)="multiSelectedOver(day)" (click)="select(day)"-->
          <time [ngClass]="{
                'border-2 rounded-2xl z-10': isDayMarked(day),
                'border-theme-primary-700': lastSelectedDay != day,
                'border-white': lastSelectedDay == day,
                }" class="mx-auto flex h-7 w-7 items-center justify-center "
                datetime="2021-12-27">{{ day.getDate() }}
          </time>

        </button>
      }
    </div>
  </div>
</div>

